import { IDeployInfo } from 'app/config/types/DeployInfo';
import { stringify } from 'query-string';
import { List } from 'immutable';
import { TeachingSkill } from './schemas';
import { BrandContextValue } from 'app/components/OrganizationContext';
import { slugify } from 'app/utils/routes';
import { includeServerName } from 'app/config/client';
import { EntityStringId } from 'app/types/entity';
import { EIKAIWA_DOMAIN } from './Eikaiwa';

export const TEACHER_SITE_DOMAIN = includeServerName('teach.engoo.com');

export const getTutorSiteUrl = (deployInfo: IDeployInfo) => {
  // The tutor site on production is not domain specific so it is okay to point directly at engoo
  return !deployInfo.serverName
    ? 'https://tutor.engoo.com'
    : `https://${deployInfo.serverName}.dev.tutor.engoo.com`;
};

const mapTeacherSkillsToInternalId = (teachingSkills: List<TeachingSkill>) => {
  return teachingSkills.map((teachingSkill) => teachingSkill.internalId).toArray();
};

/**
 * Calculate a search query url on Engoo or DMM Eikaiwa.
 * NOTE: This is only intended to be used with First Party Organizations
 */
export const getSearchTutorUrl = ({
  teachingSkills,
  brand,
}: {
  teachingSkills: List<TeachingSkill>,
  // The base for the teacher search:
  // On Engoo this would be <engoo domain>/tutors
  // On DMM this is eikaiwa.dmm.com/list/
  brand: BrandContextValue,
}) => {
  const teacherType = mapTeacherSkillsToInternalId(teachingSkills);
  // TODO: This code is relying on first party flags to determine where to send users
  // when searching for teachers. A more general solution would mean configuring these
  // routes and query schemas on the brand.
  if (brand.firstPartyDmm) {
    const query = stringify({ 'data[tab1][type][]': teacherType });
    return `https://eikaiwa.dmm.com/list/?${query}`;
  } else { // TODO: this assumes if it wasn't DMM it is Engoo
    const query = stringify({ teacher_type: teacherType });
    // The engoo site parses parameters from the Location hash field.
    return `https://${brand.defaultDomain.hostname}#?${query}`;
  }
};

export const isTeacherSite = (hostname: string) => {
  return hostname === TEACHER_SITE_DOMAIN;
};

// Helper for making tutor overrides.
export const TEACHER_RTC_GUIDE_URL =
  'https://tutor.engoo.com/support#reamaze#0#/kb/others/lesson-room-troubleshooting-guide-ts';

export const getUKnowAnchorProfileRoute = (id: EntityStringId, slug: string): string =>
  `https://${includeServerName(EIKAIWA_DOMAIN)}/uknow/anchors/${slugify(slug, 'anchor')}/${id}`;
